import PropTypes from 'prop-types';
import React from 'react';

const StoreLocationAddressCard = ({ store = null }) => {
  if (!store) return null;

  const {
    city,
    countryRegion,
    handle,
    phoneNumber,
    stateProvince,
    storeName,
    streetAddress,
    zipPostalCode,
  } = store;

  return (
    <div key={handle}>
      <a href={`/pages/${handle}`} className="block">
        <h3 className="font-bold">
          {storeName?.split(' - ').map((name, index) => {
            return index === 0 ? (
              <span className="block text-xl" key={name}>
                {name}
              </span>
            ) : (
              <span className="text-md block text-gray-500" key={name}>
                {name}
              </span>
            );
          })}
        </h3>
        <p>{streetAddress}</p>
        <p>
          {city}, {stateProvince} {zipPostalCode}
        </p>
        <p>{countryRegion}</p>
      </a>
      {phoneNumber && (
        <a className="hover:underline" href={`tel: ${phoneNumber}`}>
          {phoneNumber}
        </a>
      )}
    </div>
  );
};

StoreLocationAddressCard.propTypes = {
  className: PropTypes.any,
  store: PropTypes.shape({
    city: PropTypes.string,
    countryRegion: PropTypes.string,
    handle: PropTypes.string,
    phoneNumber: PropTypes.string,
    stateProvince: PropTypes.string,
    storeName: PropTypes.string,
    streetAddress: PropTypes.string,
    zipPostalCode: PropTypes.string,
  }),
};

export default StoreLocationAddressCard;
